import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Loader } from '@mantine/core';
import api from '../../api/axios';

const Shop = () => {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await api.get('/fetch-shop-items');

                let images = response.data
                for (let i = 0; i < images.length; i++) {
                    if  (images[i].image_url_arr[0].endsWith('.heic')) {
                        images[i].image_url_arr[0] = images[i].image_url_arr[0].replaceAll('.heic', '.jpg')
                    }
                }
                setItems(images);
                setLoading(false);
            } catch (err) {
                setFailed(true);
            }
        }
        fetchItems();
    }, [])

    return (
        <div className='flex flex-row w-full'>
            {failed
                ? <div role='alert' className='flex flex-col items-center gap-4 w-full pt-24 px-4 text-center'>
                    <div className='text-white text-xl font-light uppercase'>The shop couldn't be loaded</div>
                    <button
                        type='button'
                        onClick={() => window.location.reload()}
                        style={{ fontFamily: 'inherit' }}
                        className='px-5 py-2 rounded-md bg-transparent text-white cursor-pointer border border-solid border-zinc-600 hover:border-white'
                    >
                        Try again
                    </button>
                </div>
                : loading
                    ? <div className='flex justify-center w-full pt-24' role='status' aria-label='Loading the shop'>
                        <Loader color='gray' size='md' />
                    </div>
                    : <Outlet
                        context={{ items }}
                    />
            }
        </div>
    )
}

export default Shop